import { render, staticRenderFns } from "./monitoreScreen.vue?vue&type=template&id=79b982e0&scoped=true&"
import script from "./monitoreScreen.vue?vue&type=script&lang=js&"
export * from "./monitoreScreen.vue?vue&type=script&lang=js&"
import style0 from "./monitoreScreen.vue?vue&type=style&index=0&id=79b982e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b982e0",
  null
  
)

export default component.exports